import React from 'react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import Header from '../components/admin/includes/Header'
import Footer from '../components/admin/includes/Footer'
import AdminHomePage from '../pages/AdminHomePage/AdminHomePage'
import AddUserPage from '../pages/AddUserPage/AddUserPage'
import CreateAdminPage from '../pages/CreateAdminPage/CreateAdminPage'
import ManageAdminsPage from '../pages/ManageAdminsPage/ManageAdminsPage'
import SearchResultsPage from '../pages/SearchResultsPage/SearchResultsPage'
import SetMaintenanceStatus from '../components/admin/SetMaintenanceStatus'
import ManageFeatureFlags from '../components/admin/ManageFeatureFlags'
import ManageReports from '../components/admin/ManageReports'
import requireAuth from '../helpers/requireAuth'
import AppRoutes from './appRoutes'

/**
 * Render all pages for the Admin side of the app.
 * @param {string} match.url
 */
const AdminPages = ({ checkMaintenanceMode }) => (
    <React.Fragment>
        <Header />
        <Route
            exact
            path={AppRoutes.adminHome()}
            component={requireAuth(
                AdminHomePage,
                ['admin', 'salesperson'],
                checkMaintenanceMode,
            )}
        />
        <Route
            exact
            path={AppRoutes.adminAddUser()}
            component={requireAuth(
                AddUserPage,
                ['admin'],
                checkMaintenanceMode,
            )}
        />
        <Route
            exact
            path={AppRoutes.adminCreateAdmin()}
            component={requireAuth(
                CreateAdminPage,
                ['admin'],
                checkMaintenanceMode,
            )}
        />
        <Route
            exact
            path={AppRoutes.adminManageAdmins()}
            component={requireAuth(
                ManageAdminsPage,
                ['admin'],
                checkMaintenanceMode,
            )}
        />
        <Route
            exact
            path={AppRoutes.adminSearch()}
            component={requireAuth(
                SearchResultsPage,
                ['admin', 'salesperson'],
                checkMaintenanceMode,
            )}
        />
        <Route
            exact
            path={AppRoutes.adminMaintenaceStatus()}
            component={requireAuth(
                SetMaintenanceStatus,
                ['admin'],
                checkMaintenanceMode,
            )}
        />
        <Route
            exact
            path={AppRoutes.adminFeatureFlags()}
            component={requireAuth(
                ManageFeatureFlags,
                ['admin'],
                checkMaintenanceMode,
            )}
        />
        <Route
            exact
            path={AppRoutes.adminReports()}
            component={requireAuth(
                ManageReports,
                ['admin'],
                checkMaintenanceMode,
            )}
        />
        <Footer />
    </React.Fragment>
)

AdminPages.propTypes = {
    match: PropTypes.shape({
        url: PropTypes.string,
    }),
    checkMaintenanceMode: PropTypes.func,
}

export default AdminPages
